module.exports = __webpack_public_path__ + "static/media/Tile Formal Trouser.ddff6803.jpg";